/* Rising Sun FPV - reticle cursor helper (V2.6). Anything the theme or an app styles with cursor: pointer also gets the green lock-on cursor. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.classList || (seen && seen.has(t))) return;
    if (seen) seen.add(t);
    if (!t.classList.contains('rs-cur-hot') && window.getComputedStyle(t).cursor === 'pointer') t.classList.add('rs-cur-hot');
  }, { passive: true });
})();